import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { connect } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import parse from "html-react-parser"
import { GatsbyImage } from "gatsby-plugin-image"
import Ad from "./ad"
import * as clipboardp from "clipboard-polyfill/text"
import { toast } from "react-toastify"
import logo from "../images/YayText.min.png"
import SearchField from "./search.js"

class Top extends React.PureComponent {
  constructor(props) {
    super(props)
    this.pre_bread_ref = React.createRef()
    this.clipboard_ref = React.createRef()
    this.state = { hasMounted: false }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
    window.addEventListener("keyup", this.handleKeyUp, true)
    document.addEventListener("click", this.handleOutsideClick, true)
    this.setState({ hasMounted: true })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener("keyup", this.handleKeyUp)
    document.removeEventListener("click", this.handleOutsideClick)
  }

  handleScroll = () => {
    let isScrolledIntoView = this.isScrolledIntoView(this.pre_bread_ref.current)
    this.props.setDocked(!isScrolledIntoView)
  }

  handleKeyUp = e => {
    const keys = {
      27: () => {
        e.preventDefault()
        this.props.toggleClipboard(true)
      },
    }

    if (keys[e.keyCode]) {
      keys[e.keyCode]()
    }
  }

  handleOutsideClick = e => {
    if (
      this.props.clipboardOpen === true &&
      this.clipboard_ref &&
      this.clipboard_ref.current &&
	  e.target
    ) {
      if (
        !this.clipboard_ref.current.contains(e.target) &&
        !e.target.classList.contains("copy")
      ) {
        this.props.toggleClipboard(true)
      }
    }
  }

  isScrolledIntoView = function(el) {
    var docViewTop = window.scrollY
    var docViewBottom = docViewTop + window.innerHeight
    var elemTop = el.offsetTop
    var elemBottom = elemTop + el.clientHeight
    return (
      elemBottom >= docViewTop &&
      elemTop <= docViewBottom &&
      elemBottom <= docViewBottom &&
      elemTop >= docViewTop
    )
  }

  render() {
    const {
      toggleNav,
      isDocked,
      breadcrumbs,
      pageTitle,
      pageSubtitle,
      moreInfo,
      pageImage,
      clipboard,
      clipboardOpen,
      topContext,
    } = this.props
    const toggleClipboard = () => {
      this.props.toggleClipboard()
    }
    const copyItem = item => {
      return () => {
        clipboardp.writeText(item.text);
        toast(topContext.notifyRecopied.string);
        (typeof window !== "undefined" && window.gtag && window.gtag("event", "copy", {
          'event_category': 'Clipboard Action',
          'event_label': item.transform
        }))
      }
    }
    const clearClipboard = () => {
      this.props.clearClipboard()
      toast(topContext.notifyEmptied.string);
      (typeof window !== "undefined" && window.gtag && window.gtag("event", "clear", {
        'event_category': 'Clipboard Action'
      }))
    }
    let breadcrumbs_list = breadcrumbs
    if (breadcrumbs.length && breadcrumbs[0].text) {
      breadcrumbs_list = [breadcrumbs]
    }
    let moreInfoLinks = null
    if (this.props.moreInfoLinks) {
      moreInfoLinks = (
        <div className="more_info_links_container">
          <div className="q">
            <FontAwesomeIcon icon={["far", "question-circle"]} width="60" />
          </div>
          <div
            className="more_info_links"
            dangerouslySetInnerHTML={{ __html: this.props.moreInfoLinks }}
          />
        </div>
      )
    }

    return (
      <Wrapper
        isDocked={isDocked}
        clipboard={clipboard}
        clipboardOpen={clipboardOpen}
        clipboardHelpOpen={this.props.clipboardHelpOpen}
      >
        <div ref={this.pre_bread_ref} className="pre_breadcrumb_section"></div>
        <div className="breadcrumb_section section">
          <div className="section_inner">
            <div
              className="toggle_nav"
              onClick={toggleNav}
              onKeyPress={toggleNav}
              tabIndex={0}
              role={`button`}
            >
              <FontAwesomeIcon icon="bars" width="19" />
            </div>
            <div className="breadcrumb_wrapper">
              {breadcrumbs_list.map((breadcrumbs, i) => {
                return (
                  <ol
                    key={`breadcrumb_i_${i}`}
                    className="breadcrumb"
                    itemScope={breadcrumbs && breadcrumbs.length > 1}
                    itemType={
                      breadcrumbs && breadcrumbs.length > 1
                        ? "http://schema.org/BreadcrumbList"
                        : undefined
                    }
                    index={`breadcrumb_${i}`}
                  >
                    {(breadcrumbs || []).map(function(breadcrumb, index) {
                      let breadcrumb_link
                      if (index === 0) {
                        breadcrumb_link = (
                          <Link to={breadcrumb.link} dangerouslySetInnerHTML={{ __html: breadcrumb.text }} />
                        )
                      } else {
                        breadcrumb_link = (
                          <li
                            itemScope
                            itemProp="itemListElement"
                            itemType="http://schema.org/ListItem"
                          >
                            {breadcrumb.link ? (
                              <Link
                                to={breadcrumb.link}
                                itemProp="item"
                                itemType="http://schema.org/Thing"
                              >
                                <span itemProp="name" dangerouslySetInnerHTML={{ __html: breadcrumb.text }} />
                              </Link>
                            ) : (
                              <span
                                itemProp="item"
                                itemType="http://schema.org/Thing"
                              >
                                <span itemProp="name" dangerouslySetInnerHTML={{ __html: breadcrumb.text }} />
                              </span>
                            )}
                            <meta itemProp="position" content={index + 1} />
                          </li>
                        )
                      }
                      return (
                        <React.Fragment key={`breadcrumb_link_+${index}`}>
                          {breadcrumb_link}{" "}
                          {index < breadcrumbs.length - 1 && <>&raquo;</>}{" "}
                        </React.Fragment>
                      )
                    })}
                  </ol>
                )
              })}
            </div>
            {this.state.hasMounted && (
              <div
                className={`clipboard_container count_${clipboard.length}`}
                ref={this.clipboard_ref}
              >
                <div
                  className="toggle_clipboard"
                  tabIndex={0}
                  onClick={toggleClipboard}
                  onKeyPress={toggleClipboard}
                  role="button"
                >
                  <FontAwesomeIcon icon={["far", "clipboard"]} width="20" />
                  <span
                    className={`clipboard-counter`}
                  >{`${clipboard.length}`}</span>
                </div>
                <div className="clipboard">
                  <div className="clipboard_title">
                    {topContext.yourClipboardHistory.string}
                    {` `}
                    {clipboard.length ? (
                      <span
                        className="toggle_help"
                        tabIndex={0}
                        role="button"
                        onClick={this.props.toggleClipboardHelp}
                        onKeyPress={this.props.toggleClipboardHelp}
                      >
                        {this.props.clipboardHelpOpen
                          ? topContext.showClipboard.string
                          : `?`}
                      </span>
                    ) : (
                      ``
                    )}
                  </div>
                  <div className="clipboard_help">
                    {topContext.yourClipboardHistoryInfo.string}
                  </div>
                  <div className="history">
                    {clipboard
                      .slice(0)
                      .reverse()
                      .map((item, i) => {
                        return (
                          <div
                            className="history_item"
                            key={`clipboard_item_${i}`}
                            tabIndex={0}
                            onClick={copyItem(item)}
                            onKeyPress={copyItem(item)}
                            role="button"
                          >
                            <div className="text">
                              <div className="copy_button">
                                <FontAwesomeIcon
                                  icon={["far", "copy"]}
                                  width="14"
                                />
                              </div>
                              {item.text}
                            </div>
                            <div className="meta">
                              {new Date(item.date).toLocaleString()} &mdash;{" "}
                              {item.transform}
                            </div>
                          </div>
                        )
                      })}
                  </div>
                  {clipboard.length ? (
                    <div
                      className="clear_clipboard_container"
                      onClick={clearClipboard}
                      onKeyPress={clearClipboard}
                      tabIndex={0}
                      role="button"
                    >
                      <span className="clear_clipboard">
                        <FontAwesomeIcon
                          icon={["far", "trash-alt"]}
                          width="14"
                        />
                      </span>
                      {` `}
                      {topContext.emptyClipboard.string}
                    </div>
                  ) : (
                    ``
                  )}
                </div>
              </div>
            )}
            <SearchField languageCode={topContext.code} />
          </div>
        </div>
        <div className="title_section section">
          <div className="section_inner">
            <div id="top"></div>
            {pageImage && (
              <div className="main_image_container">
                <GatsbyImage
                  className="main_image"
                  image={pageImage.childImageSharp.gatsbyImageData}
                  loading="eager"
                  alt=""
                />
              </div>
            )}
            <Link to={topContext.code === "en" ? `/` : `/${topContext.code}/`}>
              <img src={logo} alt="YayText!" width="257px" height="111px" />
            </Link>
            <h2 dangerouslySetInnerHTML={{ __html: pageTitle }} />
            {pageSubtitle && <h3 className="subtitle">{pageSubtitle}</h3>}
            {moreInfo &&
              (typeof moreInfo === "string" ? parse(moreInfo) : moreInfo)}
            {moreInfoLinks}
          </div>
        </div>
        {moreInfo && (
          <div className="section hasAd">
            <div className="section_inner">
              <Ad
                ezoic_placeholder_id="113"
                ad_style={{
                  minHeight: "280px",
                  width: "100%",
                }}
                adsense_slot={moreInfo ? "2830409798" : false}
                adsense_format="auto"
                freestarPlacementName="yaytext_inlist_atf"
              />
            </div>
          </div>
        )}
      </Wrapper>
    )
  }
}

export default connect(
  state => {
    return {
      isDocked: state.isDocked,
      clipboard: state.clipboard,
      clipboardOpen: state.clipboardOpen,
      clipboardHelpOpen: state.clipboardHelpOpen,
    }
  },
  dispatch => {
    return {
      toggleClipboard: close =>
        dispatch({ type: `TOGGLE_CLIPBOARD`, close: close }),
      toggleClipboardHelp: () => dispatch({ type: `TOGGLE_CLIPBOARD_HELP` }),
      clearClipboard: () => dispatch({ type: `CLEAR_CLIPBOARD` }),
      toggleNav: () => dispatch({ type: `TOGGLE_NAV` }),
      setDocked: isDocked =>
        dispatch({ type: `TOGGLE_DOCK`, isDocked: isDocked }),
    }
  }
)(Top)

const Wrapper = styled("div")`
  .search {
    float: right;
    width: 250px;
    margin-right: 0.5em;
    .sui-search-box__text-input {
      padding: 2px 4px;
      font-size: 12px;
    }
    @media screen and (max-width: 600px) {
      float: left;
      clear: left;
      width: 100%;
      margin-top: 4px;
    }
    .pill {
      font-size: 10px;
      line-height: 16px;
      padding: 2px;
      color: #888;
      background-color: #eee;
      border-radius: 2px;
      float: right;
      display: block;
    }
  }
  .ad {
    .section_inner {
      background: rgb(96, 184, 195);
    }
  }
  .toggle_nav {
    float: left;
    font-size: 19px;
    line-height: 20px;
    margin-right: 8px;
    padding: 0;
    cursor: pointer;
    width: 17px;
  }
  @media (hover: hover) {
    .toggle_nav:hover {
      color: white;
    }
  }
  .pre_breadcrumb_section {
    float: left;
    width: 1px;
    height: ${props => {
      return props.isDocked ? "67px" : 0
    }};
  }
  .section.title_section {
    padding-top: 0 !important;
  }
  .section.breadcrumb_section {
    ${props => {
      if (!props.isDocked) {
        return `padding: 10px;
				overflow: visible;
				height: 67px;`
      } else {
        return `background-color: #60b7c2;
				border-bottom: 1px solid #FFFFFF55;
				height: auto;
				position: fixed;
				top: 0;
				z-index: 2000;
				box-sizing: border-box;
				padding: 10px !important;
				@media screen and (max-width: 600px) {
		      padding: 10px 5px !important;
		    }
				overflow: visible;`
      }
    }}
  }
  .section.breadcrumb_section .section_inner {
    ${props => {
      if (props.isDocked) {
        return `max-width: none;`
      }
    }}
    @media screen and (min-width: 1415px) {
      margin-left: 0;
    }
  }
  .breadcrumb_wrapper {
    float: left;
    max-width: calc(100% - 50px);
  }
  .breadcrumb {
    font-size: 17px;
    line-height: 20px;
    margin: 0;
    padding: 0;
    float: left;
    clear: left;
    @media screen and (max-width: 600px) {
      font-size: 13px;
    }
  }
  .breadcrumb li {
    list-style: none;
    display: inline;
    margin: 0;
    padding: 0;
  }
  .breadcrumb a {
    color: inherit;
  }

  .main_image_container {
    @media screen and (max-width: 800px) {
      display: none;
    }
  }

  .main_image {
    clear: right;
    float: right;
    min-width: 400px;
    min-height: 400px;
    max-width: 100%;
    height: auto;
    margin: 0 0 10px 10px;
    box-sizing: border-box;
  }

  .more_info_links_container {
    float: left;
    width: 100%;
    .q {
      color: #ffffff80;
      font-size: 60px;
      width: 60px;
      float: left;
    }
    .more_info_links {
      box-sizing: border-box;
      border: 1px solid #ffffff80;
      padding: 0.8em 0.3em 0.3em 0.3em;
      margin: 0 0 1.5em 10px;
      float: left;
      width: calc(100% - 70px);
      min-height: 60px;
      p {
        font-size: 0.9em;
        line-height: 1.2;
        margin: 0 0 0.5em;
      }
    }
  }

  .clipboard_container {
    float: right;
    position: relative;
    width: 25px;
  }

  .toggle_clipboard {
    font-size: 20px;
    line-height: 1;
    padding-right: 10px;
    cursor: pointer;
    position: relative;
  }

  @media (hover: hover) {
    .toggle_clipboard:hover {
      color: white;
    }
  }

  .clipboard {
    background: #fff;
    position: absolute;
    right: 0;
    width: 300px;
    height: 200px;
    top: 20px;
    ${props => {
      if (!props.clipboardOpen) {
        return `display: none;`
      }
    }}
    box-sizing: border-box;
    padding: 2px;
    box-shadow: 0px 2px 20px 0px #447a82;
    font-size: 14px;
    z-index: 2000;
  }

  .clipboard::after {
    bottom: 100%;
    left: calc(100% - 5px);
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: #fff;
    border-width: 5px;
    margin-left: -5px;
  }

  .clipboard_title {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #333;
    margin: 0 0 8px 0;
    font-weight: bold;
    line-height: 23px;
  }

  .clipboard .copy_button {
    float: right;
    margin-left: 0.5em;
    line-height: 1;
    margin-top: 5px;
  }

  .clipboard .toggle_help {
    font-size: 10px;
    cursor: pointer;
    padding: 0 6px;
    line-height: 23px;
    background: #eee;
  }

  .clipboard .toggle_help:hover {
    background: #333;
    color: #fff;
  }

  .clipboard .history,
  .clipboard .clipboard_help {
    overflow-y: scroll;
    height: calc(100% - 32px - 20px);
  }

  .clipboard .clipboard_help {
    ${props => {
      if (!props.clipboardHelpOpen) {
        return `display: none;`
      }
    }}
  }

  .clipboard .history {
    ${props => {
      if (props.clipboardHelpOpen) {
        return `display: none;`
      }
    }}
  }

  .clipboard .history_item {
    padding: 0 4px;
    margin: 0 0 8px 0;
    width: 100%;
    line-height: 1.2;
    box-sizing: border-box;
    cursor: pointer;
  }

  .clipboard .history_item:hover {
    background: #eef0ee;
  }

  .clipboard .history_item .text {
    white-space: pre-wrap;
  }

  .clipboard .history_item .meta {
    font-size: 12px;
    color: #888;
  }

  .clear_clipboard_container {
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    width: 100%;
    text-align: center;
    background: #eee;
    cursor: pointer;
  }

  .clear_clipboard_container:hover {
    background: #ccc;
  }

  .clipboard-counter {
    position: absolute;
    top: -2px;
    left: 11px;
    background-color: rgba(212, 19, 13, 1);
    color: #fff;
    border-radius: 3px;
    padding: 1px 3px;
    font: 8px Verdana;
  }
  .clipboard_container.count_0 .toggle_clipboard {
    padding-right: 0;
  }
  .clipboard_container.count_0 .clipboard-counter {
    display: none;
  }
`
